module.exports = __webpack_public_path__ + "img/1564563083.ee697d36.jpg";